import React from "react";
import { ListGroup, Button } from "react-bootstrap";
import { Draggable } from "@hello-pangea/dnd";

const ShoppingListItem = ({ item, removeItem, isBought, index }) => {
    if (!item || !item.id) {
        console.error("❌ Chyba: Chybějící nebo neplatná položka v seznamu!", item);
        return null;
    }

    return (
        <Draggable draggableId={String(item.id)} index={index}>
            {(provided, snapshot) => (
                <ListGroup.Item
                    className={`shopping-item ${isBought ? "bought-item" : "to-buy-item"} ${snapshot.isDragging ? "dragging" : ""}`}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={{
                        ...provided.draggableProps.style,
                        position: snapshot.isDragging ? "fixed" : "relative", // Fix pozice
                        top: snapshot.isDragging ? `${window.scrollY + 10}px` : "auto", // Korekce Y posunutí
                        left: snapshot.isDragging ? "50%" : "auto", // Vycentrování
                        transform: snapshot.isDragging ? "translate(-50%, -50%)" : "none",
                        zIndex: snapshot.isDragging ? 9999 : "auto", // Zajistí správné vrstvení
                        transition: snapshot.isDragging ? "none" : "transform 0.2s ease",
                    }}
                >
                    <span>{item.name} - {item.amount} {item.unit}</span>&nbsp;
                    {!isBought && (
                        <Button variant="danger" size="sm" onClick={() => removeItem(item.id)}>
                            <i className="bi bi-trash3"></i>
                        </Button>
                    )}
                </ListGroup.Item>
            )}
        </Draggable>
    );
};

export default ShoppingListItem;
